<template>
<div class="elementSelector_box">
    <el-dialog
        v-model="dialogVisible"
        :title="titleObj[group]"
        :width="'800px'"
        :close-on-click-modal="false"
        center
        :top="'4vh'"
        @close="handleClose"
    >
        <div class="elementSelector_contentBox">
            <div class="elementSelector_leftBox">
                <div class="elementSelector_tree">
                    <el-input v-model="groupKeys" @input="toSetFilterKey" @clear="toSetFilterKey" clearable placeholder="输入关键词搜索" size="default" />
                    <div class="elementSelector_treeItem">
                        <el-tree :data="treeData" @node-click="handleNodeClick" ref="eleSelect_tree" node-key="id" highlight-current :current-node-key="curFlowId" 
                            :filter-node-method="filterFunc"
                        >
                            <template #default="{ node }">
                                <div class="nav_item" :title="node.data.data[keyObj[group]['key'] + '_name']">
                                    <div class="nav_header">
                                        <i class="iconfont icon-a-9"></i>
                                        <!-- <img  v-else style="height:14px; margin-right: 6px;" :src="require('@img/bizFlow/treeIcon'+(group || '')+'.png')" alt=""> -->
                                        {{node.data.data[keyObj[group]['key'] + '_name'] }}
                                    </div>
                                </div>
                            </template>    
                        </el-tree>
                    </div>
                </div>
            </div>
            <div class="elementSelector_centerBox" v-if="group != 14">
                <i class="iconfont icon-down1"></i>
            </div>
            <div class="elementSelector_leftBox"  v-if="group != 14">
                <div class="elementSelector_list">
                    <el-input v-model="valuesKeys" placeholder="输入关键词搜索" size="default" />
                    <div class="elementSelector_listItem" v-if="dataList.filter((zitem)=>{return zitem[keyObj[group]['dataKey'] + '_name'].includes(valuesKeys)}).length > 0">
                        <div class="elementSelector_valueItem" 
                        @click="selectItemFunc(item)" 
                        v-for="item,index of dataList.filter((zitem)=>{return zitem[keyObj[group]['dataKey'] + '_name'].includes(valuesKeys)})" :key="index">
                            <div class="checkBox"><el-checkbox v-model="selectValues[item[keyObj[group]['dataKey'] + '_id']]" size="large" /></div> 
                            <div class="elementSelector_name">{{ item[keyObj[group]['dataKey'] + '_name'] }}</div>
                        </div>
                    </div>
                    <div class="elementSelector_empty" v-else>
                        暂无数据
                    </div>
                </div>
            </div>
            <div class="elementSelector_centerBox">
                <i class="iconfont icon-down1"></i>
            </div>
            <div class="elementSelector_rightBox">
                <div class="elementSelector_tipsBox">
                    <div>已选:{{ (Object.values(selectValues).filter((item)=>{return item})).length }}</div>
                    <div @click="clearSelect(null)">全部清空</div>
                </div>
                <div class="elementSelector_selectBox">
                    <div class="elementSelector_selItem" v-for="item,index of allList.filter((citem)=>{
                        return selectValues[citem[keyObj[group]['dataKey'] + '_id']] 
                    })" :key="index">
                        <div class="elementSelector_name">{{ item[keyObj[group]['dataKey'] + '_name'] }}</div>
                        <div class="elementSelector_delIcon" @click="clearSelect(item)">
                            <i class="iconfont icon-cuowutishi"></i>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <template #footer>
        <div class="dialog-footer">
                <el-button @click="dialogVisible = false">取消</el-button>
                <el-button type="primary" @click="selectFunc()">
                    确认
                </el-button>
        </div>
        </template>
    </el-dialog>
</div>
</template>
    
<script>
export default {
    props:{
        modelValue:{
            type:Array,
            default:function(){
                return []
            }
        },
        dialogFlag:{
            type:Boolean,
            default:function(){
                return false
            }
        },
        isMulti:{
            type:Boolean,
            default:function(){
                return true
            }
        },
        group:{
            type:Number,
            default:function(){
                return null
            }
        },
        nodeType:{
            type:String,
            default:function(){
                return ''
            }
        },
        
    },
    data() {
        return {
            dialogVisible:false,
            selectValues:{},
            groupKeys:'',
            valuesKeys:'',
            titleObj:{
                0:'授权',
                1:'绩效指标',
                2:'风险控制',
                5:'文件',
                9:'IT系统',
                10:'能力体系',
                11:'制度体系',
                12:'名词术语',
                13:'岗位选择器',
                14:'部门选择器',
            },
            keyObj:{
                0:{
                    key:'bfag',
                    dataKey:'bfa',
                },
                1:{
                    key:'big',
                    dataKey:'bin',
                },
                2:{
                    key:'bfrg',
                    dataKey:'bfr',
                },
                5:{
                    key:'bfpg',
                    dataKey:'bfp',
                },
                9:{
                    key:'bfitg',
                    dataKey:'bfit',
                },
                10:{
                    key:'bfcsg',
                    dataKey:'bfcs',
                },
                11:{
                    key:'bfig',
                    dataKey:'bfi',
                },
                12:{
                    key:'bfntg',
                    dataKey:'bfnt',
                },
                13:{
                    key:'bd',
                    dataKey:'bp',
                },
                14:{
                    key:'bd',
                    dataKey:'bd',
                },
            },
            treeData:[],
            dataList:[],
            filterName:{
                10:require('@img/bizFlow/tbl.png'),
                11:require('@img/know/noe.png'),
                12:require('@img/know/know.png'),
                'txt':require('@img/know/noe.png'),
                'doc':require('@img/know/doc.png'),
                'docx':require('@img/know/doc.png'),
                'xlsx':require('@img/know/xls.png'),
                'xls':require('@img/know/xls.png'),
                'xlsm':require('@img/know/xls.png'),
                'ppt':require('@img/know/ppt.png'),
                'pdf':require('@img/know/pdf.png'),
                'mp3':require('@img/know/mp3.png'),
                'mp4':require('@img/know/mp4.png'),
                'avi':require('@img/know/mp4.png'),
                'zip':require('@img/know/zip.png'),
                'rar':require('@img/know/zip.png'),
                'jpg':require('@img/know/img.png'),
                'png':require('@img/know/img.png'),
                'gif':require('@img/know/img.png'),
                'jpeg':require('@img/know/img.png'),
            },
            allList:[],
            curFlowId:'',
        }
    },
    watch:{
        dialogFlag: {
            handler(newVal) {
                if(newVal){
                    this.dialogVisible = true
                    this.treeData = []
                    this.dataList = []
                    if(this.modelValue){
                        for(let key of this.modelValue){
                            this.selectValues[key] = true
                        }
                    }
                    else{
                        this.selectValues = {}
                    }
                    this.queryKeyEleGroupByType(this.group)
                    this.queryKeyEleByIds()
                }
            },
            deep: true,
            immediate: true
        },
    },
    components: {
        
    },
    mounted() {

    },
    methods: {
        queryKeyEleGroupByType(){
            let apiList = this.$api.newBpa.queryKeyEleGroupByType
            if(this.group == 13 || this.group == 14){
                apiList = this.$api.newBpa.queryBfDepTree
            }
            this.$http.post(apiList, {
                keyEleType:this.group,
            }).then(res => {
                this.treeData = res.payload || []
                for(let item of this.treeData) {
                    item.id = item.data[this.keyObj[this.group]['key'] + '_id']
                    if(item.children.length>0) {
                        this.recurTree(item.children)
                    }
                }
            })
            
        },
        recurTree(arr) {
            for(let item of arr) {
                item.id = item.data[this.keyObj[this.group]['key'] + '_id']
                if(item.children.length>0) {
                    this.recurTree(item.children)
                }
            }
        },
        queryKeyEleByIds(){
            if(this.group == 14){
                this.$http.post(this.$api.newBpa.queryBfDepList, {// 岗位等回显
                    'bdIds':this.modelValue,
                }).then(res => {
                    this.allList = res.payload || [];
                })
            }
            else if(this.group == 13){
                this.$http.post(this.$api.newBpa.queryBfPostList, {// 岗位等回显
                    'bpIds':this.modelValue,
                }).then(res => {
                    this.allList = res.payload || [];
                })
            }
            else{
                this.$http.post(this.$api.newBpa.queryKeyEleByIds, {
                    keyEleType:this.group,
                    'keyEleIds':this.modelValue,
                }).then(res => {
                    this.allList = res.payload || [];
                })
            }

        },
        queryKeyEleByTypeAndGroupId(){
            let apiList = this.$api.newBpa.queryKeyEleByTypeAndGroupId
            if(this.group == 13){
                apiList = this.$api.newBpa.queryBfPostList
            }
            this.$http.post(apiList, {
                keyEleType:this.group,
                "groupId": this.curFlowId,
                [this.keyObj[this.group]['key'] + '_id']:this.curFlowId,
                "pageCur":1,
                "pageSize":999,
            }).then(res => {
                this.dataList = res.payload.dataList || res.payload || [];
            })
        },
        handleClose(){
            this.$emit('update:dialogFlag',false)
        },
        handleNodeClick(node){
            this.curFlowId = node.id
            if(this.group == 14){
                this.selectItemFunc(node.data)
            }
            else{
                this.queryKeyEleByTypeAndGroupId()
            }
        },
        selectItemFunc(item){
            if(!this.isMulti){
                this.selectValues = {}
                this.allList = []
            }
            if(item){
                this.selectValues[item[this.keyObj[this.group]['dataKey'] + '_id']] = !this.selectValues[item[this.keyObj[this.group]['dataKey'] + '_id']]
                if(this.selectValues[item[this.keyObj[this.group]['dataKey'] + '_id']]){
                    this.allList.push(item)
                }
                else{
                    this.allList = this.allList.filter((zitem)=>{
                            return zitem[this.keyObj[this.group]['dataKey'] + '_id'] != item[this.keyObj[this.group]['dataKey'] + '_id']
                    })
                }
            }
        },
        clearSelect(item){
            if(item){
               delete this.selectValues[item[this.keyObj[this.group]['dataKey'] + '_id']]
               this.allList = this.allList.filter((zitem)=>{
                    return zitem[this.keyObj[this.group]['dataKey'] + '_id'] != item[this.keyObj[this.group]['dataKey'] + '_id']
               })
            }
            else{
                this.selectValues = {}
                this.allList = []
            }
        },
        selectFunc(){
            let list = Object.keys(this.selectValues).filter(zitem=>{
                return this.selectValues[zitem]
            })
            this.$emit('selectFunc',list)
            this.dialogVisible = false
        },
        toSetFilterKey(){
            this.$refs['eleSelect_tree'].filter(this.groupKeys)
        },
        filterFunc(node,data){
            if(node){
                return  data.data & data.data[this.keyObj[this.group]['dataKey'] + '_name'].includes(node)
            }
            else{
                return true
            }
        },
    }
}
</script>

<style lang="scss" scoped>
.elementSelector_box{
    .elementSelector_contentBox{
        height: 440px;
        display: flex;
        justify-content: center;
        padding: 10px 0;
        color: #303033;
        .elementSelector_leftBox{
            flex: 1;
            border: 1px solid #E1E1E5;
            border-radius: 4px;
            height: 100%;
            display: flex;
            align-items: center;
            overflow: hidden;
            :deep(.el-input__wrapper){
                box-shadow: none;
                border-bottom: 1px solid #E1E1E5;
                border-radius: 0;
            }
            .elementSelector_tree{
                flex: 1;
                height: 100%;
                --el-disabled-bg-color:#fff;
                .elementSelector_treeItem{
                    padding-top: 5px;
                    height: calc(100% - 42px);
                    overflow: auto;
                    box-sizing: border-box;
                }
                .nav_header{
                    display: flex;
                    align-items: center;
                    line-height: 14px;
                    i{
                        color:#a1a2ab;
                        margin-right: 6px;
                    }
                }
            }
            .elementSelector_list{
                flex: 1;
                height: 100%;
                .elementSelector_listItem{
                    padding-top: 5px;
                    height: calc(100% - 42px);
                    overflow: auto;
                    box-sizing: border-box;
                    img{
                        height: 16px;
                        margin: 0 5px 0 10px;
                    }
                }
                .elementSelector_valueItem{
                    display: flex;
                    align-items: center;
                    height: 38px;
                    line-height: 38px;
                    padding: 0 15px;
                    cursor: pointer;
                    transition: all 0.25s;
                    .elementSelector_name{
                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        width: 170px;
                        margin-left: 6px;
                    }
                    &:hover{
                        background-color: #F0F0F5;
                    }
                    .checkBox{
                        pointer-events: none;
                    }
                }
            }
        }
        .elementSelector_centerBox{
            padding: 0 12px;
            height: 100%;
            display: flex;
            align-items: center;
            i{  
                font-size: 20px;
                color: #909099;
            }
        }
        .elementSelector_rightBox{
            flex: 1;
            border: 1px solid #E1E1E5;
            border-radius: 4px;
            height: 100%;
            overflow: hidden;
            .elementSelector_tipsBox{
                display: flex;
                align-items: center;
                justify-content: space-between;
                padding: 0 12px;
                height: 32px;
                font-size: 12px;
                color: #909099;
                border-bottom:  1px solid #E1E1E5;
                >div{
                    cursor: pointer;
                }
            }
            .elementSelector_selectBox{
                padding: 12px;
                box-sizing: border-box;
                height: calc(100% - 42px);
                overflow: auto;
                .elementSelector_selItem{
                    display: flex;
                    align-items: center;
                    height: 38px;
                    padding: 0 15px;
                    cursor: pointer;
                    transition: all 0.25s;
                    background-color: #F0F0F5;
                    margin-bottom: 5px;
                    border-radius: 4px;
                    position: relative;
                    &:hover{
                        .elementSelector_delIcon{
                            display: block;
                        }
                    }
                    .elementSelector_delIcon{
                        position: absolute;
                        right: -5px;
                        top: -5px;
                        cursor: pointer;
                        color: #909099;
                        display: none;
                    }
                    .elementSelector_name{
                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        width: 175px;
                        line-height: 14px;
                    }
                    img{
                        height: 16px;
                        margin: 0 5px 0 0px;
                    }
                }
            }
        }
    }
    :deep(.el-tree-node__content){
        height: 38px;
    }
    :deep(.el-tree-node){
        &:focus{
            >.el-tree-node__content{
                border-left: 2px solid #3370FF;
                background-color: #3370FF1A;
            }
        }
        
        >.el-tree-node__content{
            border-left: 2px solid transparent;
            transition: all 0.25s;
            &:hover{
                background-color: #3370FF1A;
            }
        }
        
    }
    .elementSelector_empty{
        color: #909099;
        font-size: 14px;
        text-align: center;
        padding: 40px 0;
    }
    .elementSelector_linkto{
        display: flex;
        justify-content: flex-end;
        align-items: center;
        color: var(--mainColor);
        cursor: pointer;
        i{
            margin-left: 2px;
        }
    }
    .dialog-footer{
        display: flex;
        justify-content: center;
        align-items: center;
    }
    :deep(.el-dialog__header) {
        border-bottom: 1px solid #dee0e3;
        padding: 10px 20px;
        margin-right: 0;
        .el-dialog__title {
            font-size: 16px;
            color: #575757;
        }
        .el-dialog__headerbtn{
            height: 36px;
        }
    }
}
</style>
          